const EXPLORER_URL = process.env.API_URL + '/health/explorer';
const XUGARHERO_ACCESSIBLE_USERS = process.env.API_URL + '/xugarhero/accessibleUsers';

const getAccessibleUsers = (context, filterPremium) => {
  return new Promise((resolve, reject) => {
    context.$http.get(XUGARHERO_ACCESSIBLE_USERS, {params: {filterPremium: filterPremium}})
      .then(response => {
        const body = response.body;
        const models = body.map(model => { return { id: model.accessibleUserId, label: model.username }; });
        resolve(models);
      }, error => {
        reject(error);
      });
  });
};

const getChart = (context, timestampFrom, timestampTo, userIdExplore) => {
  return new Promise((resolve, reject) => {
    context.$http.get(EXPLORER_URL, {
      params: {
        timestampFrom: timestampFrom,
        timestampTo: timestampTo,
        userIdExplore: userIdExplore
      }
    })
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getChart,
  getAccessibleUsers
};



// WEBPACK FOOTER //
// ./src/brand/health/api/healthExplorer/index.js